import { ColorSchemeScript, MantineProvider } from '@mantine/core';
import { cssVariablesResolver, theme } from '../theme/theme-override';

export interface ThemeProviderProps {
  readonly children?: React.ReactNode;
}

/**
 * ThemeProvider handles the application's visual styling and color scheme.
 * It injects the Mantine theme, CSS variable overrides, and the color scheme management script.
 */
export function ThemeProvider({ children }: ThemeProviderProps) {
  return (
    <>
      <ColorSchemeScript defaultColorScheme="auto" />
      <MantineProvider
        theme={theme}
        defaultColorScheme="auto"
        cssVariablesResolver={cssVariablesResolver}
      >
        {children}
      </MantineProvider>
    </>
  );
}
